import { render } from "./Informacoes.vue?vue&type=template&id=3ac41bba&scoped=true"
import script from "./Informacoes.vue?vue&type=script&lang=js"
export * from "./Informacoes.vue?vue&type=script&lang=js"

import "./Informacoes.vue?vue&type=style&index=0&id=3ac41bba&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ac41bba"]])

export default __exports__